// extracted by mini-css-extract-plugin
export var arrow = "_3x-6";
export var changeItem = "_3x-3";
export var changesHeader = "_3x-1";
export var changesList = "_3x-2";
export var container = "_3x-0";
export var pathLabel = "_3x-4";
export var value = "_3x-7";
export var valuesContainer = "_3x-5";